import { LearningActivityStudioVersionHistoryPage } from '@hendrx/core/learningActivity/pages/LearningActivityStudioVersionHistoryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
)({
  component: RouteComponent
});

function RouteComponent() {
  const { learningActivityDraftId, learningActivitySnapshotId } = Route.useParams();
  return (
    <LearningActivityStudioVersionHistoryPage
      learningActivityDraftId={learningActivityDraftId}
      learningActivitySnapshotId={learningActivitySnapshotId}
    />
  );
}
